import { MotivationCardTab } from "motivationCard/MotivationCardTab";
import { ScoreReportType } from "goalsCard/store/ScoreReportType";
import pl from "shared/messages/pl";
import { View360CardTab } from "view360Card/models";

export const constants = {
    taskDetailsDateFormat: "dd MMMM yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    dayOnlyDateFormat: "dd",
    queryStringDateFormat: "yyyy-MM-dd",
    commentDateFormat: "dd MMMM yyyy HH:mm",
    dateFormatYear: "yyyy",

    reportTabs: {
        monthly: {
            key: ScoreReportType.MONTHLY,
            content: pl.reports.tabs.monthly,
        },
        quarterly: {
            key: ScoreReportType.QUARTERLY,
            content: pl.reports.tabs.quarterly,
        },
        monthly_rms: {
            key: ScoreReportType.MONTHLY_RMS,
            content: pl.reports.tabs.monthly_rms,
        },
    },

    motivationCardTabs: [
        {
            key: MotivationCardTab.SALESRANK_MONTHLY,
            content: pl.motivationCard.tabs.salesRankMonthly,
        },
        {
            key: MotivationCardTab.SALESRANK_QUARTERLY,
            content: pl.motivationCard.tabs.salesRankQuarterly,
        },
    ],

    view360CardTabs: {
        generalInformation: {
            key: View360CardTab.GENERAL_INFORMATION,
            content: pl.view360Card.tabs.generalInformation,
        },
        employees: {
            key: View360CardTab.EMPLOYEES,
            content: pl.view360Card.tabs.employees,
        },
        sales: {
            key: View360CardTab.SALES,
            content: pl.view360Card.tabs.sales,
        },
        notes: {
            key: View360CardTab.NOTES,
            content: pl.view360Card.tabs.notes,
        },
    },

    defaultNavigateBackView360Tab: "general-information",

    percent: "%",
    megabytesAbbr: "MB",
    dash: "-",
    arrowUp: "▲",
    arrowDown: "▼",
    enterKeyCode: 13,
    fractionDigits: 0,
    inlineSeparator: "/",
    noValue: "-",

    defaultTagColor: "000000",
    actionIconColor: "#5b5fc7",
    qualitySignCode: "ZJ",

    tableMaxDefaultSize: 3,

    filesDownloadUrl: "/public/file/download",

    mediumDeviceWidthPx: 768,
    // use desktop view on "iPad" family devices. Break down into mobile view for smart phones
    view360MobileDeviceWidthPx: 660,
    // For v360 reports break down "higher" to handle charts view and multi-value filters
    view360ReportsMobileDeviceWidthPx: 960,

    negativeTarget: -1,

    filesValidationCodes: {
        fileTooLarge: "file-too-large",
        tooManyFiles: "too-many-files",
    },

    attributeCodes: {
        sellerInformation: "SELLER_INFORMATION",
        diagnosis: "DIAGNOSIS_MULTI",
        implementedAction: "IMPLEMENTED_ACTION_MULTI",
    },

    dictionaryKeys: {
        taskTypes: "TASK_TYPE",
    },

    taskTypesDictionaryValues: {
        informative: "INFORMATIVE",
    },

    taskStatuses: {
        closed: "CLOSED",
    },

    dynamicAttributeTypes: {
        stringAttrType: "STRING",
        longAttrType: "LONG",
        decimalAttrType: "DECIMAL",
        dateAttrType: "DATE",
        dateTimeAttrType: "DATETIME",
        boolAttrType: "BOOLEAN",
    },

    dynamicAttributeCodes: {
        infoportalRegistratorionEhm: "INFOPORTAL_REGISTRATION_EHM",
        infoportalRegistratorionEhz: "INFOPORTAL_REGISTRATION_EHZ",
        ipunktCoinsTotal: "IPUNKT_COINS_TOTAL",
        ipunktCoinsPaid: "IPUNKT_COINS_PAID",
    },

    systems: {
        ehm: {
            jupiter: "JUPITER",
            ihestia: "IHESTIA",
        },
        ehz: {
            SYRIUSZ: "SYRIUSZ",
            ERGO4: "ERGO4",
        },
    },

    unitTypes: {
        number: "NUMBER",
        numeric: "NUMERIC",
        percentage: "PERCENTAGE",
        string: "STRING",
    },

    v360ReportThemeNames: {
        blue: "blue",
        green: "green",
        pink: "pink",
        red: "red",
    },

    v360ReportCodes: {
        salesPerson: {
            salesOverviewSection: {
                monthly: "SALESPERSON_MONTHLY_SALES",
                cumulative: "SALESPERSON_SALES_CUMULATIVE",
                structure: "SALESPERSON_SALES_STRUCTURE",
            },
            salesAndActivitySection: {
                sales: "SALESPERSON_SALES",
                activity: "SALESPERSON_ACTIVITY",
            },
        },
        intermediary: {
            salesOverviewSection: {
                monthly: "INTERMEDIARY_MONTHLY_SALES",
                cumulative: "INTERMEDIARY_SALES_CUMULATIVE",
                structure: "INTERMEDIARY_SALES_STRUCTURE",
                claimRatio: "INTERMEDIARY_CLAIM_RATIO",
            },
            salesAndActivitySection: {
                sales: "INTERMEDIARY_SALES",
                activity: "INTERMEDIARY_ACTIVITY",
            },
            customersSection: {
                customers: "INTERMEDIARY_CUSTOMER",
            },
            othersSection: {
                other: "INTERMEDIARY_OTHER",
            },
        },
    },
};
